import { render, staticRenderFns } from "./ViewEditGroup.vue?vue&type=template&id=55c624b6"
import script from "./ViewEditGroup.vue?vue&type=script&lang=js"
export * from "./ViewEditGroup.vue?vue&type=script&lang=js"
import style0 from "./ViewEditGroup.vue?vue&type=style&index=0&id=55c624b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports